export enum RoutineLevel {
  ADAPTATION = 'ADAPTATION',
  BEGINNER = 'BEGINNER',
  INTERMEDIATE = 'INTERMEDIATE',
  ADVANCED = 'ADVANCED'
}

export const RoutineLevelDB = [
  { label: 'routine.level.adaptation', value: RoutineLevel.ADAPTATION },
  { label: 'routine.level.beginner', value: RoutineLevel.BEGINNER },
  { label: 'routine.level.intermediate', value: RoutineLevel.INTERMEDIATE },
  { label: 'routine.level.advanced', value: RoutineLevel.ADVANCED }
]
